export default __webpack_public_path__ + "static/media/whatAreCostcodes.9ceed212.svg";